import { getCoreSonarObjectsProfilesAsyncSlice } from './get';

export const { requestGetCoreSonarObjectsProfiles, resetGetCoreSonarObjectsProfiles } =
	getCoreSonarObjectsProfilesAsyncSlice.asyncActionCreators;
